// extracted by mini-css-extract-plugin
export var breadcrumb = "_1j-0";
export var breadcrumbArrow = "_1j-1";